/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useEffect, useState } from 'react';
import { VideoPool } from './VideoPool';
import { VideoPoolContextValue } from './VideoPoolContextTypes';

export const VideoPoolContext = createContext<VideoPoolContextValue | null>(null);

export const VideoPoolProvider: React.FC<{ children: React.ReactNode; maxSize?: number }> = ({
  children,
  maxSize = 5,
}) => {
  // Lazily construct the pool once and keep it stable across renders
  // But NOT across HMR reloads (which is what we want)
  const [pool] = useState(() => new VideoPool(maxSize));

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      pool.clear();
    };
  }, [pool]);

  const value: VideoPoolContextValue = {
    pool,
    getMetrics: () => pool.getMetrics(),
  };

  return <VideoPoolContext.Provider value={value}>{children}</VideoPoolContext.Provider>;
};
